import { render, staticRenderFns } from "./Administratori.vue?vue&type=template&id=2528d5be&scoped=true&"
import script from "./Administratori.vue?vue&type=script&lang=js&"
export * from "./Administratori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2528d5be",
  null
  
)

export default component.exports